import {
  INTERNET_CONNECTED_STATUS_CHANGED,
  ATTACH_CONNECT_POLICY,
  ATTACH_CONNECT_POLICY_SUCCESS,
  ATTACH_CONNECT_POLICY_ERROR,
  ATTACH_SUBSCRIBE_POLICY,
  ATTACH_SUBSCRIBE_POLICY_SUCCESS,
  ATTACH_SUBSCRIBE_POLICY_ERROR,
  ATTACH_PUBLIC_PUBLISH_POLICY,
  ATTACH_PUBLIC_PUBLISH_POLICY_SUCCESS,
  ATTACH_PUBLIC_PUBLISH_POLICY_ERROR,
  ATTACH_PUBLIC_RECEIVE_POLICY,
  ATTACH_PUBLIC_RECEIVE_POLICY_SUCCESS,
  ATTACH_PUBLIC_RECEIVE_POLICY_ERROR,
  ACQUIRE_POLICIES_START,
  ACQUIRE_POLICIES_SUCCESS,
  ACQUIRE_POLICIES_ERROR,
  SET_DEVICE_STATUS,
  IOT_CONNECT_CALLBACK_START,
  IOT_CONNECT_CALLBACK_SUCCESS,
  IOT_CONNECT_CALLBACK_ERROR,
  IOT_CLOSE_CALLBACK_START,
  IOT_CLOSE_CALLBACK_SUCCESS,
  IOT_CLOSE_CALLBACK_ERROR,
  MESSAGE_HANDLER_ATTACHED,
  CLEAR_SUBSCRIBED_TOPICS,
  CLEAR_POLICIES,
  ADD_SUBSCRIBED_TOPIC,
  IOT_ERROR_OCCURRED,
  SET_IOT_CLIENT_ID
} from "../actions";

const INIT_STATE = {
  loading: false,
  subscribedTopics: [],
  connectPolicy: false,
  deviceStatus: "none",
  publicReceivePolicy: false,
  subscribePolicy: false,
  publicPublishPolicy: false,
  acquiredPolicies: false,
  messageHandlerAttached: false,
  clientId: null,
  internetConnected: null,
  error: false
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_SUBSCRIBED_TOPIC: {
      const { subscribedTopics } = state;
      subscribedTopics.push(action.payload);
      return { ...state, subscribedTopics };
    }
    case ATTACH_CONNECT_POLICY:
      return { ...state, loading: true };
    case ATTACH_CONNECT_POLICY_SUCCESS:
      return { ...state, loading: false, connectPolicy: action.payload || true };
    case ATTACH_CONNECT_POLICY_ERROR:
      return { ...state, loading: false, connectPolicy: false, error: action.payload };
    case ACQUIRE_POLICIES_START:
      return { ...state, loading: true };
    case ACQUIRE_POLICIES_SUCCESS:
      return { ...state, loading: false, acquiredPolicies: action.payload || true };
    case ACQUIRE_POLICIES_ERROR:
      return { ...state, loading: false, acquiredPolicies: false, error: action.payload };
    case ATTACH_SUBSCRIBE_POLICY:
      return { ...state, loading: true };
    case ATTACH_SUBSCRIBE_POLICY_SUCCESS:
      return { ...state, loading: false, subscribePolicy: action.payload || true };
    case ATTACH_SUBSCRIBE_POLICY_ERROR:
      return { ...state, loading: false, subscribePolicy: false, error: action.payload };
    case ATTACH_PUBLIC_PUBLISH_POLICY:
      return { ...state, loading: true };
    case ATTACH_PUBLIC_PUBLISH_POLICY_SUCCESS:
      return { ...state, loading: false, publicPublishPolicy: action.payload || true };
    case ATTACH_PUBLIC_PUBLISH_POLICY_ERROR:
      return { ...state, loading: false, publicPublishPolicy: false, error: action.payload };
    case ATTACH_PUBLIC_RECEIVE_POLICY:
      return { ...state, loading: true };
    case ATTACH_PUBLIC_RECEIVE_POLICY_SUCCESS:
      return { ...state, loading: false, publicReceivePolicy: action.payload || true };
    case ATTACH_PUBLIC_RECEIVE_POLICY_ERROR:
      return { ...state, loading: false, publicReceivePolicy: false, error: action.payload };
    case IOT_CONNECT_CALLBACK_START:
      return { ...state, loading: true };
    case IOT_CONNECT_CALLBACK_SUCCESS:
      return { ...state, loading: false };
    case IOT_CONNECT_CALLBACK_ERROR:
      return { ...state, loading: false, deviceStatus: "error", error: action.payload || "something went wrong..." };
    case IOT_CLOSE_CALLBACK_START:
      return { ...state, loading: true };
    case IOT_CLOSE_CALLBACK_SUCCESS:
      return { ...state, loading: false };
    case IOT_CLOSE_CALLBACK_ERROR:
      return { ...state, loading: false, deviceStatus: "error", error: action.payload || "something went wrong..." };
    case SET_DEVICE_STATUS:
      return { ...state, deviceStatus: action.payload };
    case INTERNET_CONNECTED_STATUS_CHANGED:
      return { ...state, internetConnected: action.payload };
    case MESSAGE_HANDLER_ATTACHED: {
      return { ...state, messageHandlerAttached: action.payload };
    }
    case SET_IOT_CLIENT_ID:
      return { ...state, clientId: action.payload };
    case CLEAR_SUBSCRIBED_TOPICS:
      return { ...state, subscribedTopics: [] };
    case CLEAR_POLICIES:
      return {
        ...state,
        connectPolicy: false,
        deviceStatus: "closed",
        publicReceivePolicy: false,
        subscribePolicy: false,
        publicPublishPolicy: false,
        acquiredPolicies: false
      };
    case IOT_ERROR_OCCURRED:
      return {
        ...state,
        loading: false,
        messageHandlerAttached: false,
        deviceStatus: "error",
        error: action.payload || "something went wrong..."
      };

    default:
      return state;
  }
};
